import Vue from 'vue';
import Vuex from 'vuex';

import clients from './modules/clients/index';
import events from './modules/events/index';
import mfa from './modules/mfa/index';
import setting from './modules/setting/index';
import emailHistory from './modules/emailHistory/index';
import oauth2 from './modules/oauth2';
import shiftboard from './modules/shiftboard';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    clients,
    events,
    mfa,
    setting,
    emailHistory,
    oauth2,
    shiftboard
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js